import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoadingInfoUser = new BehaviorSubject(true);
  public isLoadingTranslate = new BehaviorSubject(false);
  public isLoadingModule = new BehaviorSubject(true);
  public isLoadingPrices = new BehaviorSubject(true);
  public isLoadingUnavailableDays = new BehaviorSubject(true);
}
